export default {
  title: "Authentication",
  subtitle: "JWT Token",
  path: "jwt_token",
  paragraphs: [
    "You will need the access token as the header of almost all the requests made via our API. To receive it, you will need to make a credential request using the information we sent you regarding your credentials. The token will be valid for 24 hours.",
    "You will receive a response with the JWT Token, which you will need to use to access the environment."
  ],
  request:  {
      method: "POST", 
      endpoint: "/sign_in",
      payload: {
        user: {
          username: "email registered",
          password: "password"
        }
      },
      responses: {
        jwt: "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9....",
        name: "name registered",
        username: "email registered"
      }  
  },
  parameterPayload: [
    {
			name: "user",
			type: "object",
			required: true,
			description: "An object containing all the required values needed"
		},
    {
      name: "user.username",
      type: "string",
      required: true,
      description: "username required to identify the user"
    },
    {
      name: "user.password",
      type: "string",
      required: true,
      description: "password required to authenticate the user"
    }
  ],
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Token.js